import { Button } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T } from '../../../../../../../Translations';

interface Props {
  onClick: () => void;
  disabled?: boolean;
}

function CreateButton({ onClick, disabled = false }: Props) {
  return (
    <Button
      size="md"
      variant="solid"
      color="primary"
      onClick={onClick}
      disabled={disabled}
      data-intercom-target="builder-v2-create-collection-button"
    >
      <T kind="Create Collection" />
    </Button>
  );
}

export default observer(CreateButton);
